import AssociationIcon from './bpmn-icon-association.svg';
import BusinessRuleTaskIcon from './bpmn-icon-business-rule-task.svg';
import CallActivityIcon from './bpmn-icon-call-activity.svg';
import CollaborationIcon from './bpmn-icon-collaboration.svg';
import ConditionalFlowIcon from './bpmn-icon-conditional-flow.svg';
import ConnectionIcon from './bpmn-icon-connection.svg';
import DataInputOutputAssociationIcon from './bpmn-icon-data-input-output-association.svg';
import DataInputIcon from './bpmn-icon-data-input.svg';
import DataObjectIcon from './bpmn-icon-data-object.svg';
import DataOutputIcon from './bpmn-icon-data-output.svg';
import DataStoreIcon from './bpmn-icon-data-store.svg';
import DefaultFlowIcon from './bpmn-icon-default-flow.svg';
import EndEventCancelIcon from './bpmn-icon-end-event-cancel.svg';
import EndEventCompensationIcon from './bpmn-icon-end-event-compensation.svg';
import EndEventErrorIcon from './bpmn-icon-end-event-error.svg';
import EndEventEscalationIcon from './bpmn-icon-end-event-escalation.svg';
import EndEventLinkIcon from './bpmn-icon-end-event-link.svg';
import EndEventMessageIcon from './bpmn-icon-end-event-message.svg';
import EndEventMultipleIcon from './bpmn-icon-end-event-multiple.svg';
import EndEventNoneIcon from './bpmn-icon-end-event-none.svg';
import EndEventSignalIcon from './bpmn-icon-end-event-signal.svg';
import EndEventTerminateIcon from './bpmn-icon-end-event-terminate.svg';
import EventSubProcessExpandedIcon from './bpmn-icon-event-subprocess-expanded.svg';
import GatewayComplexIcon from './bpmn-icon-gateway-complex.svg';
import GatewayEventBasedIcon from './bpmn-icon-gateway-eventbased.svg';
import GatewayNoneIcon from './bpmn-icon-gateway-none.svg';
import GatewayOrIcon from './bpmn-icon-gateway-or.svg';
import GatewayParallelIcon from './bpmn-icon-gateway-parallel.svg';
import GatewayXorIcon from './bpmn-icon-gateway-xor.svg';
import GroupIcon from './bpmn-icon-group.svg';
import IntermediateEventCatchCancelIcon from './bpmn-icon-intermediate-event-catch-cancel.svg';
import IntermediateEventCatchCompensationIcon from './bpmn-icon-intermediate-event-catch-compensation.svg';
import IntermediateEventCatchConditionIcon from './bpmn-icon-intermediate-event-catch-condition.svg';
import IntermediateEventCatchErrorIcon from './bpmn-icon-intermediate-event-catch-error.svg';
import IntermediateEventCatchEscalationIcon from './bpmn-icon-intermediate-event-catch-escalation.svg';
import IntermediateEventCatchLinkIcon from './bpmn-icon-intermediate-event-catch-link.svg';
import IntermediateEventCatchMessageIcon from './bpmn-icon-intermediate-event-catch-message.svg';
import IntermediateEventCatchMultipleIcon from './bpmn-icon-intermediate-event-catch-multiple.svg';
import IntermediateEventCatchNonInterruptingConditionIcon from './bpmn-icon-intermediate-event-catch-non-interrupting-condition.svg';
import IntermediateEventCatchNonInterruptingEscalationIcon from './bpmn-icon-intermediate-event-catch-non-interrupting-escalation.svg';
import IntermediateEventCatchNonInterruptingMessageIcon from './bpmn-icon-intermediate-event-catch-non-interrupting-message.svg';
import IntermediateEventCatchNonInterruptingMultipleIcon from './bpmn-icon-intermediate-event-catch-non-interrupting-multiple.svg';
import IntermediateEventCatchNonInterruptingParallelIcon from './bpmn-icon-intermediate-event-catch-non-interrupting-parallel.svg';
import IntermediateEventCatchNonInterruptingSignalIcon from './bpmn-icon-intermediate-event-catch-non-interrupting-signal.svg';
import IntermediateEventCatchNonInterruptingTimerIcon from './bpmn-icon-intermediate-event-catch-non-interrupting-timer.svg';
import IntermediateEventCatchParallelMultipleIcon from './bpmn-icon-intermediate-event-catch-parallel-multiple.svg';
import IntermediateEventCatchSignalIcon from './bpmn-icon-intermediate-event-catch-signal.svg';
import IntermediateEventCatchTimerIcon from './bpmn-icon-intermediate-event-catch-timer.svg';
import IntermediateEventNoneIcon from './bpmn-icon-intermediate-event-none.svg';
import IntermediateEventThrowCompensationIcon from './bpmn-icon-intermediate-event-throw-compensation.svg';
import IntermediateEventThrowEscalationIcon from './bpmn-icon-intermediate-event-throw-escalation.svg';
import IntermediateEventThrowLinkIcon from './bpmn-icon-intermediate-event-throw-link.svg';
import IntermediateEventThrowMessageIcon from './bpmn-icon-intermediate-event-throw-message.svg';
import IntermediateEventThrowMultipleIcon from './bpmn-icon-intermediate-event-throw-multiple.svg';
import IntermediateEventThrowSignalIcon from './bpmn-icon-intermediate-event-throw-signal.svg';
import LaneIcon from './bpmn-icon-lane.svg';
import ManualTaskIcon from './bpmn-icon-manual-task.svg';
import MessageFlowIcon from './bpmn-icon-message-flow.svg';
import ParticipantIcon from './bpmn-icon-participant.svg';
import ProcessIcon from './bpmn-icon-process.svg';
import ReceiveTaskIcon from './bpmn-icon-receive-task.svg';
import ScriptTaskIcon from './bpmn-icon-script-task.svg';
import SendTaskIcon from './bpmn-icon-send-task.svg';
import ServiceTaskIcon from './bpmn-icon-service-task.svg';
import StartEventCompensationIcon from './bpmn-icon-start-event-compensation.svg';
import StartEventConditionIcon from './bpmn-icon-start-event-condition.svg';
import StartEventErrorIcon from './bpmn-icon-start-event-error.svg';
import StartEventEscalationIcon from './bpmn-icon-start-event-escalation.svg';
import StartEventMessageIcon from './bpmn-icon-start-event-message.svg';
import StartEventMultipleIcon from './bpmn-icon-start-event-multiple.svg';
import StartEventNonInterruptingConditionIcon from './bpmn-icon-start-event-non-interrupting-condition.svg';
import StartEventNonInterruptingEscalationIcon from './bpmn-icon-start-event-non-interrupting-escalation.svg';
import StartEventNonInterruptingMessageIcon from './bpmn-icon-start-event-non-interrupting-message.svg';
import StartEventNonInterruptingMultipleIcon from './bpmn-icon-start-event-non-interrupting-multiple.svg';
import StartEventNonInterruptingParallelMultipleIcon from './bpmn-icon-start-event-non-interrupting-parallel-multiple.svg';
import StartEventNonInterruptingSignalIcon from './bpmn-icon-start-event-non-interrupting-signal.svg';
import StartEventNonInterruptingTimerIcon from './bpmn-icon-start-event-non-interrupting-timer.svg';
import StartEventNoneIcon from './bpmn-icon-start-event-none.svg';
import StartEventParallelMultipleIcon from './bpmn-icon-start-event-parallel-multiple.svg';
import StartEventSignalIcon from './bpmn-icon-start-event-signal.svg';
import StartEventTimerIcon from './bpmn-icon-start-event-timer.svg';
import SubprocessCollapsedIcon from './bpmn-icon-subprocess-collapsed.svg';
import SubprocessExpandedIcon from './bpmn-icon-subprocess-expanded.svg';
import TaskNoneIcon from './bpmn-icon-task-none.svg';
import TextAnnotationicon from './bpmn-icon-text-annotation.svg';
import TransactionIcon from './bpmn-icon-transaction.svg';
import UserTaskIcon from './bpmn-icon-user-task.svg';

export default {
  'Association': AssociationIcon,
  'BusinessRuleTask': BusinessRuleTaskIcon,
  'CallActivity': CallActivityIcon,
  'Collaboration': CollaborationIcon,
  'ConditionalFlow': ConditionalFlowIcon,
  'SequenceFlow': ConnectionIcon,
  'DataInput': DataInputIcon,
  'DataInputAssociation': DataInputOutputAssociationIcon,
  'DataOutput': DataOutputIcon,
  'DataOutputAssociation': DataInputOutputAssociationIcon,
  'DataObjectReference': DataObjectIcon,
  'DataStoreReference': DataStoreIcon,
  'DefaultFlow': DefaultFlowIcon,
  'CancelEndEvent': EndEventCancelIcon,
  'CompensateEndEvent': EndEventCompensationIcon,
  'ErrorEndEvent': EndEventErrorIcon,
  'EscalationEndEvent': EndEventEscalationIcon,
  'LinkEndEvent': EndEventLinkIcon,
  'MessageEndEvent': EndEventMessageIcon,
  'MultipleEndEvent': EndEventMultipleIcon,
  'EndEvent': EndEventNoneIcon,
  'SignalEndEvent': EndEventSignalIcon,
  'TerminateEndEvent': EndEventTerminateIcon,
  'EventSubProcess': EventSubProcessExpandedIcon,
  'ComplexGateway': GatewayComplexIcon,
  'EventBasedGateway': GatewayEventBasedIcon,
  'ExclusiveGateway': GatewayXorIcon,
  'Gateway': GatewayNoneIcon,
  'InclusiveGateway': GatewayOrIcon,
  'ParallelGateway': GatewayParallelIcon,
  'Group': GroupIcon,
  'CancelIntermediateCatchEvent': IntermediateEventCatchCancelIcon,
  'CompensateIntermediateCatchEvent': IntermediateEventCatchCompensationIcon,
  'ConditionalIntermediateCatchEvent': IntermediateEventCatchConditionIcon,
  'ErrorIntermediateCatchEvent': IntermediateEventCatchErrorIcon,
  'EscalationIntermediateCatchEvent': IntermediateEventCatchEscalationIcon,
  'LinkIntermediateCatchEvent': IntermediateEventCatchLinkIcon,
  'MessageIntermediateCatchEvent': IntermediateEventCatchMessageIcon,
  'MultipleIntermediateCatchEvent': IntermediateEventCatchMultipleIcon,
  'ConditionalIntermediateCatchEventNonInterrupting': IntermediateEventCatchNonInterruptingConditionIcon,
  'EscalationIntermediateCatchEventNonInterrupting': IntermediateEventCatchNonInterruptingEscalationIcon,
  'MessageIntermediateCatchEventNonInterrupting': IntermediateEventCatchNonInterruptingMessageIcon,
  'MultipleIntermediateCatchEventNonInterrupting': IntermediateEventCatchNonInterruptingMultipleIcon,
  'ParallelIntermediateCatchEventNonInterrupting': IntermediateEventCatchNonInterruptingParallelIcon,
  'SignalIntermediateCatchEventNonInterrupting': IntermediateEventCatchNonInterruptingSignalIcon,
  'TimerIntermediateCatchEventNonInterrupting': IntermediateEventCatchNonInterruptingTimerIcon,
  'ParallelMultipleIntermediateCatchEvent': IntermediateEventCatchParallelMultipleIcon,
  'SignalIntermediateCatchEvent': IntermediateEventCatchSignalIcon,
  'TimerIntermediateCatchEvent': IntermediateEventCatchTimerIcon,
  'IntermediateThrowEvent': IntermediateEventNoneIcon,
  'CompensateIntermediateThrowEvent': IntermediateEventThrowCompensationIcon,
  'EscalationIntermediateThrowEvent': IntermediateEventThrowEscalationIcon,
  'LinkIntermediateThrowEvent': IntermediateEventThrowLinkIcon,
  'MessageIntermediateThrowEvent': IntermediateEventThrowMessageIcon,
  'MultipleIntermediateThrowEvent': IntermediateEventThrowMultipleIcon,
  'SignalIntermediateThrowEvent': IntermediateEventThrowSignalIcon,
  'Lane': LaneIcon,
  'ManualTask': ManualTaskIcon,
  'MessageFlow': MessageFlowIcon,
  'Participant': ParticipantIcon,
  'Process': ProcessIcon,
  'ReceiveTask': ReceiveTaskIcon,
  'ScriptTask': ScriptTaskIcon,
  'SendTask': SendTaskIcon,
  'ServiceTask': ServiceTaskIcon,
  'CompensateStartEvent': StartEventCompensationIcon,
  'ConditionalStartEvent': StartEventConditionIcon,
  'ErrorStartEvent': StartEventErrorIcon,
  'EscalationStartEvent': StartEventEscalationIcon,
  'MessageStartEvent': StartEventMessageIcon,
  'MultipleStartEvent': StartEventMultipleIcon,
  'ConditionalStartEventNonInterrupting': StartEventNonInterruptingConditionIcon,
  'EscalationStartEventNonInterrupting': StartEventNonInterruptingEscalationIcon,
  'MessageStartEventNonInterrupting': StartEventNonInterruptingMessageIcon,
  'MultipleStartEventNonInterrupting': StartEventNonInterruptingMultipleIcon,
  'ParallelMultipleStartEventNonInterrupting': StartEventNonInterruptingParallelMultipleIcon,
  'SignalStartEventNonInterrupting': StartEventNonInterruptingSignalIcon,
  'TimerStartEventNonInterrupting': StartEventNonInterruptingTimerIcon,
  'CancelBoundaryEvent': IntermediateEventCatchCancelIcon,
  'CompensateBoundaryEvent': IntermediateEventCatchCompensationIcon,
  'ConditionalBoundaryEvent': IntermediateEventCatchConditionIcon,
  'ErrorBoundaryEvent': IntermediateEventCatchErrorIcon,
  'EscalationBoundaryEvent': IntermediateEventCatchEscalationIcon,
  'LinkBoundaryEvent': IntermediateEventCatchLinkIcon,
  'MessageBoundaryEvent': IntermediateEventCatchMessageIcon,
  'MultipleBoundaryEvent': IntermediateEventCatchMultipleIcon,
  'BoundaryEvent': IntermediateEventNoneIcon,
  'ConditionalBoundaryEventNonInterrupting': IntermediateEventCatchNonInterruptingConditionIcon,
  'EscalationBoundaryEventNonInterrupting': IntermediateEventCatchNonInterruptingEscalationIcon,
  'MessageBoundaryEventNonInterrupting': IntermediateEventCatchNonInterruptingMessageIcon,
  'MultipleBoundaryEventNonInterrupting': IntermediateEventCatchNonInterruptingMultipleIcon,
  'ParallelBoundaryEventNonInterrupting': IntermediateEventCatchNonInterruptingParallelIcon,
  'SignalBoundaryEventNonInterrupting': IntermediateEventCatchNonInterruptingSignalIcon,
  'TimerBoundaryEventNonInterrupting': IntermediateEventCatchNonInterruptingTimerIcon,
  'ParallelMultipleBoundaryEvent': IntermediateEventCatchParallelMultipleIcon,
  'SignalBoundaryEvent': IntermediateEventCatchSignalIcon,
  'TimerBoundaryEvent': IntermediateEventCatchTimerIcon,
  'StartEvent': StartEventNoneIcon,
  'ParallelMultipleStartEvent': StartEventParallelMultipleIcon,
  'SignalStartEvent': StartEventSignalIcon,
  'TimerStartEvent': StartEventTimerIcon,
  'CollapsedSubProcess': SubprocessCollapsedIcon,
  'CollapsedAdHocSubProcess': SubprocessCollapsedIcon,
  'ExpandedSubProcess': SubprocessExpandedIcon,
  'ExpandedAdHocSubProcess': SubprocessExpandedIcon,
  'Task': TaskNoneIcon,
  'TextAnnotation': TextAnnotationicon,
  'Transaction': TransactionIcon,
  'UserTask': UserTaskIcon
};